import React from 'react'

export const RadioQuestion = ({ children }) => {
    return (
        <>
            {children}
        </>
    )
}
